import { SurveyViewModel } from "../Contexts/SessionState";

export function surveyRefsMatch(left: string | null | undefined, right: string | null | undefined): boolean {
    const normalizedLeft = left?.trim();
    const normalizedRight = right?.trim();
    if (!normalizedLeft || !normalizedRight) return false;
    if (normalizedLeft === normalizedRight) return true;

    // Historical sessions sometimes stored only the site/survey reference.  If
    // either side has no date, compare the part before the date suffix.
    return (!normalizedLeft.includes("|") || !normalizedRight.includes("|")) &&
        normalizedLeft.split("|", 1)[0] === normalizedRight.split("|", 1)[0];
}

export function getValidActiveSurveyRefs(
    selectedSitesAndSurveys: SurveyViewModel[] | null | undefined,
    filteredSurveyIds: string[],
): string[] {
    if (!selectedSitesAndSurveys?.length) {
        // Sessions saved before survey selection was recorded must continue to
        // use the current filtered list.
        return Array.from(new Set(filteredSurveyIds));
    }

    const activeSelections = selectedSitesAndSurveys.filter(s => s.siteActive && s.surveyActive);
    return Array.from(new Set(
        filteredSurveyIds.filter(filteredRef =>
            activeSelections.some(selection => surveyRefsMatch(selection.surveyRef, filteredRef)))
    ));
}

export function getTripRateCalculationSurveyRefs(
    search: string,
    selectedSitesAndSurveys: SurveyViewModel[],
    filteredSurveyIds: string[],
): string[] {
    const query = new URLSearchParams(search);
    const selectedSurvey = query.get("selectedSurvey");
    const surveyDate = query.get("surveyDate");

    if (selectedSurvey) {
        return surveyDate ? [`${selectedSurvey}|${surveyDate}`] : [selectedSurvey];
    }

    return getValidActiveSurveyRefs(selectedSitesAndSurveys, filteredSurveyIds);
}
